import { useFormik } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import eyeClose from "assets/svg/eyeClose.svg";
import eyeOpen from "assets/svg/eyeOpen.svg";
import { useEffect, useState } from "react";
import { resetPassword } from "../../../axios/api";
import { toast } from "react-toastify";
import Loader from "../../../components/loader";

export default function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const location = useLocation();
  const response = location.state?.response.data.user;

  const navigate = useNavigate();
  !response?.email && navigate("/auth/signin");
  const formik = useFormik({
    initialValues: {
      email: response?.email,
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Required"),
      newPassword: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character"
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const response = await resetPassword({
          email: values.email,
          newPassword: values.newPassword,
          confirmPassword: values.confirmPassword,
        });
        // console.log("responsesss", JSON.stringify(response));

        if (response?.data?.success) {
          toast.success("Login Success!");
          // console.log(response?.data, "response?.data?.data");
          // localStorage.setItem("token", response?.data?.result?.token);
          // localStorage.setItem("role", response?.data?.data?.user);
          // localStorage.setItem(
          //   "username",
          //   response?.data?.result?.user?.username
          // );
          window.location.href = "/admin/announcement";
        } else {
          // console.log(response?.data?.message);
          toast.error(response?.data?.message);
        }
      } catch (error: any) {
        console.log(error);
        toast.error(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  const handlePasswordShow = () => {
    setShowPassword(!showPassword);
  };

  const handleConfirmPasswordShow = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/admin/announcement");
    } else {
      setLoading(false);
    }
  }, [navigate]);

  const EyeIcon = showPassword ? eyeOpen : eyeClose;
  const EyeIcon2 = showConfirmPassword ? eyeOpen : eyeClose;
  const passwordType = showPassword ? "text" : "password";
  const confirmPasswordType = showConfirmPassword ? "text" : "password";

  return (
    <>
      {loading && <Loader />}
      <div className="flex min-h-[100%] items-center justify-center">
        <div className="w-[65%]">
          <div className="text-4xl	font-bold text-[#2B3674]">Reset Password</div>
          <div className="mt-3	 text-base	font-normal text-[#A3AED0]">
            Enter your email and new password to reset your password!
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="py-2">
              <div className="py-3">
                <label
                  className="text-xl font-medium	text-[#2B3674]	"
                  htmlFor="email"
                >
                  Email <span className="text-[#008BD2]">*</span>
                </label>
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formik.values.email}
                  className="h-[3.5rem] w-[100%] rounded-[1rem] border-[1px]  border-[#A3AED0] p-5 text-lg"
                  placeholder="Enter email here"
                  disabled
                />
              </div>
            </div>

            <div className="py-2">
              <div className="py-3">
                <label
                  className="text-xl font-medium	text-[#2B3674]	"
                  htmlFor="newPassword"
                >
                  New Password <span className="text-[#008BD2]">*</span>
                </label>
              </div>
              <div className="relative">
                <input
                  id="newPassword"
                  name="newPassword"
                  type={passwordType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.newPassword}
                  className="h-[3.5rem] w-[100%] rounded-[1rem] border-[1px]  border-[#A3AED0] p-5 text-lg"
                  placeholder="Enter new password here"
                />
                <div
                  className="jusitify-center absolute right-4 top-0 flex  h-[3.5rem] cursor-pointer items-center"
                  onClick={handlePasswordShow}
                >
                  <img
                    src={EyeIcon}
                    alt="eyeOpen"
                    className="h-[1.25rem] w-[1.25rem]"
                  />
                </div>
              </div>

              {formik.touched.newPassword && formik.errors.newPassword ? (
                <div className="text-lg	text-red-600">
                  {formik.errors.newPassword}
                </div>
              ) : null}
            </div>

            <div className="py-2">
              <div className="py-3">
                <label
                  className="text-xl font-medium	text-[#2B3674]	"
                  htmlFor="confirmPassword"
                >
                  Confirm Password <span className="text-[#008BD2]">*</span>
                </label>
              </div>
              <div className="relative">
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type={confirmPasswordType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.confirmPassword}
                  className="h-[3.5rem] w-[100%] rounded-[1rem] border-[1px]  border-[#A3AED0] p-5 text-lg"
                  placeholder="Enter new password again"
                />
                <div
                  className="jusitify-center absolute right-4 top-0 flex  h-[3.5rem] cursor-pointer items-center"
                  onClick={handleConfirmPasswordShow}
                >
                  <img
                    src={EyeIcon}
                    alt="EyeIcon2"
                    className="h-[1.25rem] w-[1.25rem]"
                  />
                </div>
              </div>

              {formik.touched.confirmPassword &&
              formik.errors.confirmPassword ? (
                <div className="text-lg	text-red-600">
                  {formik.errors.confirmPassword}
                </div>
              ) : null}
            </div>

            <button
              type="submit"
              className="mt-5 h-[3.5rem] w-[100%] cursor-pointer rounded-full bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-700"
            >
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
